export default __webpack_public_path__ + "static/media/contact-2.d29f5d90.jpg";